/**
 * Policy pages (Settings > Policies) have no template file to add markup to: Shopify prints
 * .shopify-policy__container itself. This adds contents, from the policy's own h2 headings, so it
 * can never fall out of step with the text (direction A, Matt's build plan, 12 Sept 2026).
 *
 * Only runs where there is something to contain: fewer than two sections and a list would just
 * repeat the page.
 */
function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function buildBackLink(labelText) {
  const p = document.createElement('p');
  p.className = 'policy-back-link';
  const a = document.createElement('a');
  a.href = '#policy-contents';
  a.textContent = labelText;
  p.append(a);
  return p;
}

function addContents(container, labels) {
  const headings = [...container.querySelectorAll('h2')];
  if (headings.length < 2) return;

  const used = new Set();
  for (const item of headings) {
    if (!item.id) {
      let id = slugify(item.textContent || '') || 'section';
      let unique = id;
      let n = 1;
      while (used.has(unique) || document.getElementById(unique)) unique = `${id}-${n++}`;
      item.id = unique;
    }
    used.add(item.id);
  }

  const backLabel = labels.back;
  const heading = labels.contents;

  const nav = document.createElement('nav');
  // sticky-content--desktop: Horizon's own sticky-under-the-header class, gated to the same
  // 750px breakpoint as the sidebar grid below (assets/base.css); the same class
  // product-information-content.liquid uses for the PDP's sticky details column. Unscoped
  // sticky-content is sticky at every width, which would stick the TOC on mobile, where it sits
  // in normal flow above the body, not in a sidebar.
  nav.className = 'policy-toc sticky-content--desktop';
  nav.id = 'policy-contents';
  nav.setAttribute('aria-label', heading);

  const h2 = document.createElement('h2');
  h2.className = 'policy-toc__heading';
  h2.textContent = heading;

  const list = document.createElement('ol');
  list.className = 'policy-toc__list';
  for (const item of headings) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${item.id}`;
    a.textContent = item.textContent;
    li.append(a);
    list.append(li);
  }

  nav.append(h2, list);
  // .shopify-policy__title is the page's own <h1>, INSIDE .shopify-policy__container as its
  // first child (confirmed on the rendered page, 13 Sept 2026: prepending to the container put
  // the contents list above the title, not below it). Placed after the title however Shopify
  // nests the two, rather than assumed to be the container's first child.
  const title = document.querySelector('.shopify-policy__title');
  if (title) title.after(nav);
  else container.prepend(nav);

  // A back-link before every heading but the first (that section already opens at the top of the
  // page), and once more at the very end, so the last section gets one too.
  for (const item of headings.slice(1)) {
    item.before(buildBackLink(backLabel));
  }
  container.append(buildBackLink(backLabel));
}

const container = document.querySelector('.shopify-policy__container');
const script = document.getElementById('policy-page-script');
if (container && script) {
  addContents(container, {
    contents: script.dataset.contentsHeading || 'Contents',
    back: script.dataset.backToContentsLabel || 'Back to contents',
  });
}
